import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

export default function useRedirectIfVerified(verified, superAdmin, tripId, locked, verificationAdmin) {
  const history = useHistory();
  const notified = useRef(false);

  useEffect(() => {
    const closed = verified || locked;

    if (closed && !superAdmin && !verificationAdmin && tripId && !notified.current) {
      notified.current = true;
      toast.info(
        verified
          ? "This trip is verified and can only be edited by an Admin."
          : "This trip is locked and can only be edited by an Admin.",
      );
      history.replace(`/trips/${tripId}`);
    }
  }, [verified, locked, superAdmin, verificationAdmin, tripId, history]);
}
